import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { PostData } from "../Functions/SendingData";
import { Loading } from "../Loading";
import FullsizeErrors from "../PopUp/FullsizeErrors";
import { insertError } from "../StakcableError";
import {formatPrice} from "../Functions/Price";
import { buyingProccess } from "../../Lang/fa/BuyingProccess";
import { goodpageText } from "../../Lang/fa/Goodpage";
import { addToCartProductDataLayer, delFromCartProductDataLayer, viewCartProductDataLayer } from "../Functions/DataLayers";
import arrow_search from '../../assets/SMSVG/arrow-search.svg'


const ProfileLayout = styled.div`
  .background-basket {
    z-index: 901;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.3);

    /* animation: background-animation 0.3s ease-in-out 1 0s forwards !important; */
  }
  /* @keyframes background-animation {
    0% {
      background-color: rgba(0, 0, 0, 0);
    }
    100% {
      background-color: rgba(0, 0, 0, 0.5);
    }
  } */
  .basket-menu {
    z-index: 903;
    overflow: hidden;
    display: flex;
    direction: rtl;
    white-space: nowrap;
    flex-direction: column;
    position: fixed;
    top: 0px;
    left: 0px;
    height: 0;
    max-height: 0;
    background-color: var(--body-2);
    text-align: right;
    border-radius: 0;
    box-shadow: 0px 5px 15px -5px #555;
    transition: all 0.3s ease-in-out;
    width: 26rem;
    &.active {
      height: 100%;
      max-height: 100vh;
      left: 0px;
      width: 26rem;
    }
    &.active2 {
      height: 100%;
      max-height: 100vh;
      left: 0px;
    }
    .top-user {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      height: 60px;
      width: calc(100% - 3.2rem);
      padding:0 1.6rem;
      align-items: center;
      .text , .count{
        font-size: 1rem;
        font-weight: 500;
        color: var(--text-8);
        display: flex;
        flex-direction: row;
        align-items: center;
        .icon{
          margin-left: 0.2rem;
          width: 1.2rem;
          height: 1.2rem;
        }
      }
      .count{
        color: var(--gray-6);
        font-size: 0.75rem;
      }
      
    }
    .part {
      display: flex;
      flex-direction: column;
      text-align: center;
      padding: 1rem 2rem;
      .title {
        font-size: var(--fs-basket-side-text);
        font-weight: 300;
        color: var(--secondry-1);
        padding: 1rem 0 0.5rem;
      }
      .link {
        text-decoration: none;
        background-color: var(--primary-1);
        color: var(--text-3);
        margin: 0.5rem 0;
        padding: 0.5rem 0;
        font-size: 1.12rem;
        border-radius: 5px;
        cursor: pointer;
      }
    }
    .last-link {
      margin: 1rem 0;
      text-align: center;
      color: var(--primary-1);
      text-decoration: none;
      font-weight: 300;
    }

    .header {
      padding: 1rem;
      display: flex;
      border-bottom: 1px solid #555;
      justify-content: space-between;
      .link {
        text-decoration: none;
        color: var(--text-2);
        transition: all 0.2s ease-in-out;
        :hover {
          color: var(--text-2);
        }
        .icon {
          margin-right: 0.5rem;
        }
      }
    }
    .cart-goods {
      margin:1rem 1.6rem;
      overflow-y: auto;
      overflow-x: hidden;
      flex-grow: 1;
      ::-webkit-scrollbar-track {
        box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.1);
        background-color: #f5f5f555;
        border-radius: 10px;
      }
      ::-webkit-scrollbar {
        width: 5px;
        background-color: #f5f5f500;
      }
      ::-webkit-scrollbar-thumb {
        border-radius: 10px;
        background-color: var(--body-1);
      }

      .cart-good {
        padding: 0.5rem 0;
        width: 100%;
        display: flex;
        flex-direction: column;
        .detail {
          display: flex;
          .image {
            width: calc(20% + 0.5rem);
            padding: 0.25rem;
            border-radius: 0.5rem;
            display: flex;
            flex-direction: column;
            justify-content: center;
            img {
              width: 100%;
            }
          }
          .details {
            width: calc(80% - 1rem);
            flex-grow: 1;
            margin-right: 0.5rem;
            overflow: hidden;
            .name {
              white-space: normal;
              padding-bottom: 0.3rem;
              font-weight: bold;
              font-size: 0.75rem;
            }
            .name-small {
              font-size: 0.75rem;
            }
            .detailcol {
              .line {
                width: 100%;
                display: flex;
                margin: 0.3rem 0;
                .color {
                  font-weight: bold;
                  font-size: var(--fs-basket-side-text);
                }
              }
            }
          }
        }
        .functions {
          display: flex;
          flex-direction: column;
          .line {
            display: flex;
            margin: 0.5rem 0;
            justify-content: space-between;
            align-items: center;  
            .delete {
              color: var(--text-2);
              font-size: var(--fs-basket-side-text);
              font-weight: 300;
              display: flex;
              flex-direction: row;
              align-items: center;
              justify-content: flex-end;
              width: calc(100% - 1rem);
              svg{
                fill: var(--primary-1);
                width: 20%;
                max-height: 2rem;
                :hover{
                  fill: var(--secondry-1);
                }
              }
              :hover {
                color: var(--text-2);
              }
            }
            .count {
              border: 1px solid var(--primary-5);
              border-radius: var(--border-radius-2);
              display: flex;
              color: var(--primary-1);
              .number {
                font-weight: 500;
                padding: 0 0.5rem;
                font-size: 1rem;
                display: flex;
                align-items: center;
                border-left: 1px solid var(--primary-5);
                border-right: 1px solid var(--primary-5);
                color: var(--primary-5);

              }
              .icon {
                padding: 0.5rem;
                cursor: pointer;
                transition: all 0.1s ease-in-out;
                fill: var(--primary-1);
                width: 1.5rem;
                height: 1.5rem;
              }
            }
            .price {
              flex-grow: 1;
              display: flex;
              font-size: 1rem;
              font-weight: 500;
              justify-content: flex-end;
              align-items: center;
              .curency {
                font-weight: 500;
                margin-right: 0.5rem;
              }
            }
          }
        }
      }
    }
    .footerbasket {
      display: flex;
      flex-direction: column;
      border-top: 1px solid var(--gray-3);
      .cart-proccess-container {
        text-align: center;
        padding: 1rem 1.6rem;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        .cart-title {
          display: flex;
          justify-content: center;
          font-size: 0.87rem;
          font-weight: 500;
          margin: 0.5rem 0 ;
          color: var(--gray-9);
          .number {
            margin: 0.2rem 0.3rem 0 0;
            font-weight: 500;
            color: var(--gray-5);
          }
        }
        .price-container {
          .title {
            margin: 0.5rem 0;
            padding-bottom: 0.5rem;
            font-size: 1.5rem;
            font-weight: 300;
          }
          .price {
            justify-content: center;
            display: flex;
            align-items: center;
            font-size: 1.25rem;
            font-weight: 500;
            color: var(--gray-5);
            .curency {
              margin-right: 0.5rem;
              font-weight: 500;
            }
          }
        }
        /* .cuts {
          border-bottom: 2px solid var(--text-2);
          padding: 0.5rem;
          display: flex;
          justify-content: space-between;
          .price {
            display: flex;
            font-weight: 800;
            .curency {
              margin-top: 0.2rem;
              margin-right: 0.5rem;
              font-size: 0.75rem;
              font-weight: normal;
            }
          }
        } */
        
        /* .text {
          margin: -2rem 0 2rem 0 !important;
          text-align: center;
          padding-right: 0;
          .link-basket {
            text-decoration: none;
            margin-top: 0.5rem;
            text-align: center;
            padding: 0.8rem 0.8rem 0.8rem;
            color: var(--secondry-1);
            font-weight: 800;
            transition: all 0.3s ease-in-out;
            width: calc(100% - 1.6rem);
            cursor: pointer;
            :hover {
              opacity: 0.9;
            }
          }
        } */
      }
     
    }
    .no-order {
      padding: 2rem 1rem 0;
      text-align: center;
      font-weight: 600;
    }
    .link {
      text-decoration: none;
      position: relative;
      width: 90%;
      padding: 1rem 0;
      cursor: pointer;
      margin: 0 auto 2rem;
      text-align: center;
      font-size: 0.87rem;
      font-weight: 700;
      background-color: var(--primary-5);
      border-radius: var(--border-radius-2);
      color: var(--text-3);
      transition: all 0.3s ease-in-out;
    }
  }

  .basket-menu .button {
    padding: 0.5rem 0;
    border-bottom: solid 1px #aaa;
  }
  .basket-menu .button a {
    color: var(--text-2);
    text-decoration: none;
  }
  .basket-menu .button a:hover {
    color: var(--text-2);
  }

  @media screen and (max-width: 850px) {
    .basket-menu {
      width: 100vw;
      &.active {
        width: 100vw;
      }
      &.active2 {
        /* height: 100vh; */
        max-height: 100vh;
        left: 0px;
      }
      .top-user {
        width: auto;
        height: 60px;
      }
      .footerbasket{
        padding-bottom: 1rem;
        .link{
          text-decoration: none;
          position: relative;
          width: 90%;
          padding: 1rem 0;
          cursor: pointer;
          margin: 0 auto;
          text-align: center;
          font-size: 0.87rem;
          font-weight: 700;
          background-color: var(--primary-5);
          border-radius: var(--border-radius-2);
          color: var(--text-3);
        }
      }
    }
  
  }
`;

class UniBasket extends React.Component {
  constructor(props) {
    super(props);
    let token = localStorage.getItem("token");
    let temp_logined = false;
    if (token !== null) {
      temp_logined = true;
    }
    this.state = {
      logined: temp_logined,
      showError: false,
      cart: JSON.parse(localStorage.getItem("basket")),
      ShowCart: false,
      userdata: JSON.parse(localStorage.getItem("userdata")),
      message:buyingProccess.addbasket,
      all: [],
    };
  }
  setAllGood=()=>{
    let all = []
    this.props.cart.map((bask)=>{
        bask.SHOP_BASKET.map((value)=>{
            all.push(value)
        })
    })
    this.setState({
      all: all,
    })
  }
  componentDidMount() {
    insertGood = this.insertGoodIntoBasket.bind(this);
    ShowCart = this.showCart.bind(this);
    if(this.props.cart) {
      if(this.props.cart.length) {
          viewCartProductDataLayer(this.props.cart)
          this.setAllGood()
      }
    }
  }
  getSnapshotBeforeUpdate(prevProps, prevState){
    if(this.props.cart !== prevProps.cart){
        return true
    }
    return false
  }
  componentDidUpdate(prevProps, prevState, snapshot){
      if(snapshot){
          if(this.props.loading){
              if (this.props.cart){
                  if(this.props.cart.length) {
                      viewCartProductDataLayer(this.props.cart)
                      this.setAllGood()
                  }
              }
          }
      }
  }
  showCart = () => {
    if (this.state.ShowCart) {
      this.setState({
        ShowCart: false,
      });
    } else {
      if (
        window.location.pathname !== "/buying/basket" &&
        window.location.pathname !== "/checkout" &&
        this.props.location.pathname.split("/")[1] !== "seller"
      ) {
        this.setState({
          ShowCart: true,
        });
      }
    }
  };
  closeprofile = () => {
    this.setState({
      ShowCart: false,
    });
    this.props.setOpen()
  };
  // error functions
  showError = (message, func) => {
    this.setState({
      showError: true,
      errorMessage: message,
      errorFunc: func,
    });
  };
  closeError = () => {
    this.props.func();
    this.setState({
      showError: false,
      errorMessage: "",
    });
  };

  basketUpdate = (good, func) => {
    if (func === "insert") {
      this.AddGoodToBasket(good);
    }
  };

  AddGoodToBasket = (good) => {
    this.props.load();
    let formData = new FormData();
    if(localStorage.getItem("token")){
      formData.append("api_token", localStorage.getItem("token"));
      formData.append("SH_G_CODE", good.SH_G_CODE);
      formData.append("TEMP_BASK_COUNT", good.TEMP_BASK_COUNT);
      PostData(
        process.env.REACT_APP_API + "/api/v1/basket/Bask_Detail/insert",
        formData,
        this,
        this.ProccessBasketAddGood
      );
    } else {
      let items = [];
      if(localStorage.getItem("luxinlux-basket")) {
        items = JSON.parse(localStorage.getItem("luxinlux-basket"));
      }
      let find = items.findIndex((v) => v.SH_G_CODE === good.SH_G_CODE);
      if(find !== -1){
        if((good.TEMP_BASK_COUNT <= this.props.cart[find].SALABLE_COUNT)){
          items[find].TEMP_BASK_COUNT = good.TEMP_BASK_COUNT      
        }else{
          insertError("تعداد سفارش از موجودی کالا بیشتر است ", "red", 5000); 
        }
      }else{
          items.push({
            SH_G_CODE: good.SH_G_CODE,
            TEMP_BASK_COUNT: good.TEMP_BASK_COUNT
          })
        
      }
      localStorage.setItem("luxinlux-basket", JSON.stringify(items))
      insertError(this.state.message, "green", 5000);
      this.props.func('small');
    }
  };

  ProccessBasketAddGood(obj, response) {
    response = JSON.parse(response);
    if (response.status === "success") {
      obj.setState({
        sending: false,
      });
      obj.props.func('small');
      insertError(obj.state.message, "green", 5000);
    } else if (response.status === "error") {
      obj.setState({
        sending: false,
      });
      obj.props.func('small');
      insertError(response.data.message, "red", 5000);
    } else if (response.status === "error-no-internet") {
      obj.setState({
        sending: false,
      });
      insertError("مشکلی در ارتباط با سرور وجود دارد", "red", 5000);
    }
  }

  insertGoodIntoBasket = (good) => {
    let cart = this.state.all;
    let index = cart.filter(
      (value) => parseInt(value.SH_G_CODE) === parseInt(good.SH_G_CODE)
    );
    if (!index.length) {
      addToCartProductDataLayer({
        ...good,
        quantity: 1,
      })
      good["TEMP_BASK_COUNT"] = 1;
      this.setState({
        message: buyingProccess.addbasket,
        ShowCart: true,
      })
      this.basketUpdate(good, "insert");
      // if (this.props.userdata) {
      //   addToCartProductDataLayer({
      //     ...good,
      //     quantity: 1,
      //   })
      //   good["TEMP_BASK_COUNT"] = 1;
      //   this.setState({
      //     message: buyingProccess.addbasket,
      //     ShowCart: true,
      //   })
      //   this.basketUpdate(good, "insert");
      // } else {
      //   insertError(
      //     buyingProccess.errorLogin,
      //     "red",
      //     5000
      //   );
      // }
    } else {
      // insertError(
      //   buyingProccess.basketError,
      //   "red",
      //   8000
      // );
      this.setState({
        message: buyingProccess.basketError,
        ShowCart: true,
      })
    }
  };

  increaseGood(i) {
    // this.props.load();
    let cart = this.state.all;
    cart[i].TEMP_BASK_COUNT += 1;
    this.setState({
      message : buyingProccess.addbasket,
      ShowCart: true,
    });
    addToCartProductDataLayer({
      ...cart[i],
      SH_G_PRICE: cart[i].TEMP_BASK_PRICE,
      quantity: 1,
    })
    this.AddGoodToBasket(cart[i]);
  }
  decreaseGood(i) {
    // this.props.load();
    let cart = this.state.all;
    cart[i].TEMP_BASK_COUNT -= 1;
    this.setState({
      message: buyingProccess.removebasket
    })
    if (cart[i].TEMP_BASK_COUNT < 1) {
      this.deleteGood(i, true);
    } else {
      delFromCartProductDataLayer({
        ...cart[i],
        SH_G_PRICE: cart[i].TEMP_BASK_PRICE,
        quantity: 1,
      })
      this.AddGoodToBasket(cart[i]);
    }
    // localStorage.setItem('basket', JSON.stringify(cart));
  }

  deleteGood = (id, within = false) => {
    let good = this.state.all[id];
    delFromCartProductDataLayer({
      ...good,
      SH_G_PRICE: good.TEMP_BASK_PRICE,
      quantity: (within) ? 1 : good.TEMP_BASK_COUNT,
    })
    if(localStorage.getItem("token")){
      let formData = new FormData();
      formData.append("api_token", localStorage.getItem("token"));
      formData.append("SH_G_CODE", good.SH_G_CODE);
      this.showError(buyingProccess.deletegood, this.confirmedDelete);
      this.setState({
        tempForm: formData,
      });
    } else {
      let formData = new FormData();
      formData.append("SH_G_CODE", good.SH_G_CODE);
      this.showError(buyingProccess.deletegood, this.confirmedDelete);
      this.setState({
        tempForm: formData,
      });
    }
    
  };

  confirmedDelete = () => {
    if(localStorage.getItem("token")){
      this.props.load();
      this.setState({
        showError: false,
        errorMessage: "",
      });
      PostData(
        process.env.REACT_APP_API + "/api/v1/basket/Bask_Detail/delete",
        this.state.tempForm,
        this,
        this.ProccessBasketdelete
      );
    } else {
      let items = [];
      if(localStorage.getItem("luxinlux-basket")) {
        items = JSON.parse(localStorage.getItem("luxinlux-basket"));
      }
      let formData = this.state.tempForm;
      let code = formData.get("SH_G_CODE");
      let find = items.findIndex((v) => v.SH_G_CODE === parseInt(code));
      if(find !== -1){
        items.splice(find, 1);
      }
      localStorage.setItem("luxinlux-basket", JSON.stringify(items));
      this.setState({
        showError: false,
        errorMessage: "",
      });
      insertError(buyingProccess.deletegooderr, "red", 5000);
      this.props.func('small');
    }
  };
  ProccessBasketdelete(obj, response) {
    response = JSON.parse(response);
    if (response.status === "success") {
      obj.setState({
        sending: false,
      });
      obj.props.func();
      insertError(buyingProccess.deletegooderr, "red", 5000);
      // localStorage.setItem('userdata', JSON.stringify(response.data));
    } else if (response.status === "error") {
      obj.setState({
        sending: false,
      });
      insertError(buyingProccess.deleteerro, "red", 5000);
    } else if (response.status === "error-no-internet") {
      obj.setState({
        sending: false,
      });
      insertError("مشکلی در ارتباط با سرور وجود دارد", "red", 5000);
    }
  }

  linkProccess = () => {
    // let ErrorLink = false;
    // this.props.cart.forEach((value) => {
    //   if (value.TEMP_BASK_DESC) {
    //     if (value.TEMP_BASK_DESC.length > 5) {
    //       ErrorLink = true;
    //     }
    //   }
    // });
    // if (ErrorLink) {
    //   return (
    //     <div className="link" style={{ opacity: "50%" }}>
    //       ادامه فرایند خرید
    //     </div>
    //   );
    // } else {
        
    // }
    return (
      <Link className="link" to="/buying/basket/" onClick={this.closeprofile}>
        {buyingProccess.continuebtn}
      </Link>
    );
  };
  cart=(value,index)=>{
    return (
      <div className="cart-good" key={index}>
        <div className="detail">
          <div className="image">
            <img src={value.G_IMAGE} alt={value.G_NAME} />
          </div>
          <div className="details">
            <div className="name">{value.G_NAME}</div>
            <div className="name-small">{value.SH_G_DESC}</div>
            <div className="detailcol">
              <div className="line">
                <div className="color">{value.G_PACK_NAME}: {value.G_COL_NAME}</div>
              </div>
            </div>
            <div className="name">فروشگاه: {value.SH_NAME}</div>
          </div>
        </div>
        <div className="functions">
          <div className="line">
            <div className="count">
              <svg  className="icon" onClick={() => this.increaseGood(index)}>
                <path d="M9.9466 9.50666V6.09333H11.6533V9.50666H15.0666V11.2133H11.6533V14.6267H9.9466V11.2133H6.53327V9.50666H9.9466ZM10.7999 18.8933C6.08697 18.8933 2.2666 15.073 2.2666 10.36C2.2666 5.64703 6.08697 1.82666 10.7999 1.82666C15.5129 1.82666 19.3333 5.64703 19.3333 10.36C19.3333 15.073 15.5129 18.8933 10.7999 18.8933ZM10.7999 17.1867C12.6105 17.1867 14.3469 16.4674 15.6271 15.1872C16.9074 13.9069 17.6266 12.1705 17.6266 10.36C17.6266 8.54945 16.9074 6.81306 15.6271 5.53281C14.3469 4.25256 12.6105 3.53333 10.7999 3.53333C8.98939 3.53333 7.253 4.25256 5.97275 5.53281C4.6925 6.81306 3.97327 8.54945 3.97327 10.36C3.97327 12.1705 4.6925 13.9069 5.97275 15.1872C7.253 16.4674 8.98939 17.1867 10.7999 17.1867Z" fill="#203569"/>
              </svg>
              <div className="number">
                {value.TEMP_BASK_COUNT} عدد
              </div>
              { value.TEMP_BASK_COUNT === 1 ?
                (
                  <svg className="icon" onClick={() => this.deleteGood(index)}>
                    <path d="M14.6267 5.23999H18.8933V6.94666H17.1867V18.04C17.1867 18.2663 17.0968 18.4834 16.9367 18.6434C16.7767 18.8034 16.5596 18.8933 16.3333 18.8933H4.38666C4.16034 18.8933 3.94329 18.8034 3.78326 18.6434C3.62323 18.4834 3.53333 18.2663 3.53333 18.04V6.94666H1.82666V5.23999H6.09333V2.67999C6.09333 2.45368 6.18323 2.23663 6.34326 2.0766C6.50329 1.91656 6.72034 1.82666 6.94666 1.82666H13.7733C13.9996 1.82666 14.2167 1.91656 14.3767 2.0766C14.5368 2.23663 14.6267 2.45368 14.6267 2.67999V5.23999ZM15.48 6.94666H5.23999V17.1867H15.48V6.94666ZM7.79999 9.50666H9.50666V14.6267H7.79999V9.50666ZM11.2133 9.50666H12.92V14.6267H11.2133V9.50666ZM7.79999 3.53333V5.23999H12.92V3.53333H7.79999Z" fill="#203569"/>
                  </svg>
                ):(
                  <svg className="icon" onClick={() => this.decreaseGood(index)}>
                    <path d="M9.99984 18.3333C5.39734 18.3333 1.6665 14.6025 1.6665 10C1.6665 5.39751 5.39734 1.66667 9.99984 1.66667C14.6023 1.66667 18.3332 5.39751 18.3332 10C18.3332 14.6025 14.6023 18.3333 9.99984 18.3333ZM9.99984 16.6667C11.7679 16.6667 13.4636 15.9643 14.7139 14.7141C15.9641 13.4638 16.6665 11.7681 16.6665 10C16.6665 8.23189 15.9641 6.5362 14.7139 5.28596C13.4636 4.03572 11.7679 3.33334 9.99984 3.33334C8.23173 3.33334 6.53603 4.03572 5.28579 5.28596C4.03555 6.5362 3.33317 8.23189 3.33317 10C3.33317 11.7681 4.03555 13.4638 5.28579 14.7141C6.53603 15.9643 8.23173 16.6667 9.99984 16.6667ZM5.83317 9.16667H14.1665V10.8333H5.83317V9.16667Z" fill="#203569"/>
                  </svg>
                )

                }
            </div>
            <div className="price">
              {formatPrice(value.TEMP_BASK_SUM)}
              <div className="curency">{goodpageText.toman}</div>
            </div>
          </div>
        </div>
      </div>
    );
  }
  
  getElements() {
    if (this.props.loading) {
      if (this.props.cart.length) {
        let totalnum = 0;
        // let items = this.props.cart.map((value, index) => {
        //   return value.SHOP_BASKET.map((value, index) => {
        //     totalnum = totalnum + value.TEMP_BASK_COUNT
        //     return this.cart(value,index)
        //   });
        // });
        let items = this.state.all.map((value, index) => {
          totalnum = totalnum + value.TEMP_BASK_COUNT
          return this.cart(value,index)
        });

        return (
          <React.Fragment>
            <div className="top-user">
              <div className="text" onClick={this.closeprofile}> 
              {window.innerWidth < 850 ? <img src={arrow_search} className='icon' alt='close'  />:''}
              سبد خرید 
              </div>
              <div className="count"> {totalnum} کالا </div>
            </div>
            <div className="cart-goods no-click-basket">{items}</div>
            <div className="footerbasket">
              <div className="cart-proccess-container">
                <div className="cart-title">
                  {buyingProccess.payable} 
                </div>
                <div className="price-container">
                  <div className="price">
                    {formatPrice(this.props.basket_sum)}
                    <div className="curency">{buyingProccess.toman} </div>
                  </div>
                </div>
              </div>
              {this.linkProccess()}
            </div>
          </React.Fragment>
        );
      } else {
        return (
          <React.Fragment>
            <div className="top-user">
            <div className="text" onClick={this.closeprofile}> 
              {window.innerWidth < 850 ? <img src={arrow_search} className='icon' alt='close'  />:''}
              سبد خرید 
              </div>
            </div>
            <div className="no-order">{buyingProccess.empty} </div>
          </React.Fragment>
        );
      }
    } else {
      return <Loading />;
    }
    // if (this.props.userdata) {
      
    // } else {
    //   return (
    //     <React.Fragment>
    //       <div className="top-user">
    //         <div
    //           className="icon"
    //           style={{
    //             justifyContent:
    //               window.innerWidth > 850 ? "end" : "space-between",
    //           }}
    //         >
    //           <div className="nav-link cls" onClick={this.closeprofile}>
    //             <svg
    //               id="Layer_1"
    //               data-name="Layer 1"
    //               xmlns="http://www.w3.org/2000/svg"
    //               viewBox="0 0 500 500"
    //             >
    //               <title>بستن</title>
    //               <path
    //                 className="cls-1"
    //                 d="M347.08,189.22,177.62,358.69a18.07,18.07,0,0,1-25.56-25.56L321.53,163.66a18.07,18.07,0,0,1,25.55,25.56Z"
    //               />
    //               <path
    //                 className="cls-1"
    //                 d="M321.53,358.69,152.06,189.22a18.07,18.07,0,0,1,25.56-25.56L347.08,333.13a18.07,18.07,0,0,1-25.55,25.56Z"
    //               />
    //             </svg>
    //           </div>
    //           <div className="nav-link no-click-cart" onClick={ShowCart}>
    //           <img className='nav-icon' src={basketIcon} alt='سبد خرید'/>
    //             <div className="small-number">{this.getAllCount()}</div>
    //           </div>
    //           <div className="nav-link no-click" onClick={ShowCart}>
    //           <img className='nav-icon' src={userIcon} alt='پروفایل'/>
    //           </div>
    //         </div>
    //       </div>
    //       <div className="text">
    //         <div className="title">برای تجربه بهتر</div>
    //         <div className="sub-title">لطفا وارد حساب کاربری شوید</div>
    //       </div>
    //       <div className="part">
    //         <div className="link" onClick={this.closeprofile}>
    //           {logintext.user}
    //         </div>
    //       </div>
         
    //       {/* <Link
    //         className="last-link"
    //         to="/user/login"
    //         onClick={this.closeprofile}
    //       >
    //         فراموشی رمز عبور
    //       </Link> */}
    //     </React.Fragment>
    //   );
    // }
  }

  // getAllCount = () => {
  //   if (this.props.loading) {
  //     let cart = this.props.cart;
  //     let count = 0;
  //     cart.forEach((value) => {
  //       count += value.TEMP_BASK_COUNT;
  //     });
  //     return count;
  //   } else {
  //     return "-";
  //   }
  // };

  // getCartPrice = () => {
  //   let cart = this.props.cart;
  //   let price = 0;
  //   cart.forEach((value) => {
  //     price += value.count * value.SH_G_PRICE;
  //   });
  //   return price;
  // };

  render() {
    let classes = "basket-menu no-click-basket";
    if (this.props.location.pathname === "/") {
      classes = "basket-menu home no-click-basket";
    }
    if (this.state.ShowCart) {
      classes = "basket-menu no-click-basket active";
      if (this.props.location.pathname === "/") {
        classes = "basket-menu home no-click-basket active2";
      }
    }
    return (
      <ProfileLayout>
        {this.state.ShowCart && (
          <div className="background-basket" onClick={this.closeprofile}></div>
        )}
        <div id="uni-basket-menu" className={classes}>
          {this.getElements()}
          <FullsizeErrors
            show={this.state.showError}
            message={this.state.errorMessage}
            confirm={this.state.errorFunc}
            close={this.closeError}
            classname={''}
          />
        </div>
      </ProfileLayout>
    );
  }
}


export var insertGood;
// export function insertGood(good) {
//   this.insertGoodIntoBasket(good);
// }
export var ShowCart;
// export function ShowCart() {
//   this.showCart();
// }


export default UniBasket;
